export const state = () => ({
  frontPriceList: null,
});
